/* Ampd Bros — Electric Bikes collection controller.
   Links the "Where will you ride?" selector, the shortcut chips, the sort
   select and any [data-ampd-chip] link (e.g. the GO App CTA) to the grid. */
(function () {
  if (window.__ampdCollection) return;
  window.__ampdCollection = true;

  var state = { ride: 'all', chip: 'all', sort: 'featured' };

  // Deep links: ?show=step|kids|offers|app  &ride=en|off  &sort=low|high|range|torque
  var CHIPS = ['all', 'offers', 'app', 'step', 'kids'];
  var RIDES = ['all', 'en', 'off'];
  var SORTS = ['featured', 'low', 'high', 'range', 'torque'];
  var fromLink = false;
  // Collection pre-selection (e.g. the Kids collection opens with Kids & Youth on)
  var gridEl = document.getElementById('ampd-bikes');
  var baseline = {
    chip: (gridEl && gridEl.dataset.initialChip) || 'all',
    ride: (gridEl && gridEl.dataset.initialRide) || 'all'
  };
  state.chip = baseline.chip;
  state.ride = baseline.ride;
  (function readUrl() {
    var q = new URLSearchParams(window.location.search);
    var show = (q.get('show') || '').toLowerCase();
    var ride = (q.get('ride') || '').toLowerCase();
    var sort = (q.get('sort') || '').toLowerCase();
    if (CHIPS.indexOf(show) > -1) { state.chip = show; fromLink = show !== baseline.chip; }
    if (RIDES.indexOf(ride) > -1) { state.ride = ride; fromLink = fromLink || ride !== baseline.ride; }
    if (SORTS.indexOf(sort) > -1) state.sort = sort;
  })();

  function writeUrl() {
    if (!window.history || !history.replaceState) return;
    var q = new URLSearchParams(window.location.search);
    state.chip === baseline.chip ? q.delete('show') : q.set('show', state.chip);
    state.ride === baseline.ride ? q.delete('ride') : q.set('ride', state.ride);
    state.sort === 'featured' ? q.delete('sort') : q.set('sort', state.sort);
    var qs = q.toString();
    history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : '') + window.location.hash);
  }

  function grid() { return document.querySelector('[data-ampd-grid]'); }
  function items() { var g = grid(); return g ? Array.prototype.slice.call(g.querySelectorAll('[data-ampd-item]')) : []; }

  function matchRide(el, ride) {
    ride = ride || state.ride;
    if (ride === 'en') return el.dataset.en === 'true';
    if (ride === 'off') return el.dataset.en !== 'true';
    return true;
  }
  function matchChip(el, chip) {
    switch (chip || state.chip) {
      case 'offers': return el.dataset.offer === 'true';
      case 'app': return el.dataset.app === 'true';
      case 'step': return el.dataset.step === 'true';
      case 'kids': return el.dataset.kids === 'true';
      default: return true;
    }
  }

  function sortItems(list) {
    var key = state.sort;
    var num = function (el, k) { return parseFloat(el.dataset[k]) || 0; };
    return list.slice().sort(function (a, b) {
      if (key === 'low') return num(a, 'price') - num(b, 'price');
      if (key === 'high') return num(b, 'price') - num(a, 'price');
      if (key === 'range') return num(b, 'range') - num(a, 'range');
      if (key === 'torque') return num(b, 'torque') - num(a, 'torque');
      // Featured: keep the merchandised order, but sold-out bikes drop to the end
      var soldA = a.dataset.sold === 'true' ? 1 : 0, soldB = b.dataset.sold === 'true' ? 1 : 0;
      if (soldA !== soldB) return soldA - soldB;
      return num(a, 'index') - num(b, 'index');
    });
  }

  function render() {
    var g = grid();
    if (!g) return;
    var visible = 0;
    sortItems(items()).forEach(function (el) {
      g.appendChild(el);
      var show = matchRide(el) && matchChip(el);
      el.hidden = !show;
      if (show) visible++;
    });

    document.querySelectorAll('[data-ampd-ride]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.dataset.ampdRide === state.ride));
    });
    document.querySelectorAll('button[data-ampd-chip]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.dataset.ampdChip === state.chip));
    });

    var title = document.querySelector('[data-ampd-title]');
    if (title) {
      var t = title.dataset.defaultTitle;
      var chipBtn = document.querySelector('button[data-ampd-chip="' + state.chip + '"]');
      var rideBtn = document.querySelector('[data-ampd-ride="' + state.ride + '"]');
      if (state.chip !== 'all' && chipBtn) t = chipBtn.dataset.title;
      else if (state.ride !== 'all' && rideBtn) t = rideBtn.dataset.label || rideBtn.dataset.title;
      title.textContent = t;
    }
    var count = document.querySelector('[data-ampd-count]');
    if (count) count.textContent = visible + (visible === 1 ? ' model' : ' models');
    var empty = document.querySelector('[data-ampd-empty]');
    if (empty) empty.hidden = visible !== 0;
    updateCounts();
    renderActive();
    var sel = document.querySelector('[data-ampd-sort]');
    if (sel && sel.value !== state.sort) sel.value = state.sort;
    writeUrl();
  }

  // Counts on each option reflect the other active filter, so "Offers 3" means
  // 3 offers within the chosen ride type.
  function updateCounts() {
    var all = items();
    document.querySelectorAll('button[data-ampd-chip]').forEach(function (b) {
      var n = all.filter(function (el) { return matchRide(el) && matchChip(el, b.dataset.ampdChip); }).length;
      var c = b.querySelector('span'); if (c) c.textContent = n;
      b.disabled = n === 0 && b.dataset.ampdChip !== state.chip;
    });
    document.querySelectorAll('[data-ampd-ride]').forEach(function (b) {
      var n = all.filter(function (el) { return matchRide(el, b.dataset.ampdRide) && matchChip(el); }).length;
      var c = b.querySelector('.ampd-seg__count'); if (c) c.textContent = n;
    });
  }

  // "Filtered by" row: makes stacked filters obvious and one-tap to undo.
  function renderActive() {
    var box = document.querySelector('[data-ampd-active]');
    if (!box) return;
    var tags = [];
    if (state.ride !== 'all') {
      var r = document.querySelector('[data-ampd-ride="' + state.ride + '"]');
      tags.push({ kind: 'ride', label: r ? (r.dataset.label || r.dataset.title) : state.ride });
    }
    if (state.chip !== 'all') {
      var c = document.querySelector('button[data-ampd-chip="' + state.chip + '"]');
      tags.push({ kind: 'chip', label: c ? c.dataset.title : state.chip });
    }
    box.hidden = tags.length === 0;
    var list = box.querySelector('[data-ampd-active-list]');
    if (!list) return;
    list.innerHTML = '';
    tags.forEach(function (t) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ampd-active__tag';
      b.setAttribute('data-ampd-clear', t.kind);
      b.setAttribute('aria-label', 'Remove filter: ' + t.label);
      b.innerHTML = '<span></span><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
      b.querySelector('span').textContent = t.label;
      list.appendChild(b);
    });
  }

  function scrollToGrid() {
    var target = document.getElementById('ampd-bikes');
    if (target) target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  }

  document.addEventListener('click', function (e) {
    var ride = e.target.closest('[data-ampd-ride]');
    if (ride) { state.ride = ride.dataset.ampdRide; render(); scrollToGrid(); return; }

    var chip = e.target.closest('[data-ampd-chip]');
    if (chip) {
      if (chip.tagName === 'A') e.preventDefault();
      state.chip = chip.dataset.ampdChip;
      render();
      if (chip.tagName === 'A') scrollToGrid();
      return;
    }

    if (e.target.closest('[data-ampd-reset]')) { state.ride = 'all'; state.chip = 'all'; render(); return; }

    var clear = e.target.closest('[data-ampd-clear]');
    if (clear) {
      if (clear.dataset.ampdClear === 'ride') state.ride = 'all'; else state.chip = 'all';
      render();
      return;
    }

    var toggle = e.target.closest('[data-ampd-toggle]');
    if (toggle) {
      var panel = document.getElementById(toggle.getAttribute('aria-controls'));
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      if (panel) panel.hidden = open;
    }
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-ampd-sort]')) { state.sort = e.target.value; render(); }
  });

  // Shopify theme editor: re-render when sections reload
  document.addEventListener('shopify:section:load', render);

  function init() {
    render();
    // Arriving from a filtered link: jump straight to the bikes
    if (fromLink) setTimeout(function () {
      var target = document.getElementById('ampd-bikes');
      if (target) target.scrollIntoView({ block: 'start' });
    }, 60);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
